export default __webpack_public_path__ + "static/media/stars.e2bcca17.jpg";